import React from 'react'
import '../style.css'

export default function Practice() {
  return (
    <div className='Typing'>
        <a class="btn btn-primary" id='pratice' href="https://blockly.games/" target="iframe_a">Start Your Practice In Coding</a>
        <iframe href="https://www.doorwayonline.org.uk/activities/text-type3/text-type.html" name="iframe_a" height="600px" width="100%" title="Iframe Example"/>
    </div>
  )
}